const salonConfig = {
  businessName: "Luxe Studio",
  businessCategory: "Salon & Beauty Studio",
  productsLabel: "Services & Products",
  tagline: "Look Good. Feel Amazing.",
  description: "Luxe Studio is a premium unisex salon offering expert hair, skin, and beauty services in a luxurious, relaxing environment.",
  mission: "To help every client look and feel their absolute best with personalised beauty solutions.",
  vision: "To be the most trusted and loved beauty destination in the city.",
  logo: null,
  favicon: null,
  theme: {
    primaryColor: "#9b5de5",
    secondaryColor: "#f15bb5",
    accentColor: "#fee440",
    backgroundColor: "#ffffff",
    textColor: "#1a1a2e",
    darkBackground: "#1a1a2e",
    darkText: "#f0e6ff",
    borderRadius: "16px",
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
  },
  darkModeEnabled: true,
  defaultDarkMode: false,
  seo: {
    title: "Luxe Studio | Premium Salon & Beauty",
    description: "Visit Luxe Studio for expert hair, skin, and beauty treatments. Book your appointment today.",
    keywords: "salon, beauty, hair, skin, makeup, spa, luxe studio",
    ogImage: "https://images.unsplash.com/photo-1560066984-138dadb4c035?w=1200&q=80",
    twitterCard: "summary_large_image",
  },
  contact: {
    phone: "+91 98765 55555",
    whatsapp: "919876555555",
    email: "book@luxestudio.com",
    website: "www.luxestudio.com",
    address: "15, Style Street, Linking Road, Bandra, Mumbai - 400050",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d241317.11609823277!2d72.74109995709657!3d19.08250589563531!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c6306644edc1%3A0x5da4ed8f8d648c69!2sMumbai%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1718000000000",
  },
  businessHours: [
    { day: "Tuesday – Friday", hours: "10:00 AM – 8:00 PM" },
    { day: "Saturday – Sunday", hours: "9:00 AM – 9:00 PM" },
    { day: "Monday", hours: "Closed" },
  ],
  social: { facebook: "https://facebook.com", instagram: "https://instagram.com", linkedin: "", youtube: "", twitter: "" },
  hero: {
    heading: "Your Beauty, Our Passion",
    subheading: "Expert stylists, premium products, and a relaxing experience tailored just for you.",
    ctaPrimary: { label: "Book Appointment", link: "/salon/contact" },
    ctaSecondary: { label: "Our Services", link: "/salon/services" },
    images: [
      "https://images.unsplash.com/photo-1560066984-138dadb4c035?w=1400&q=80",
      "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=1400&q=80",
      "https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?w=1400&q=80",
    ],
  },
  about: {
    heading: "About Luxe Studio",
    subheading: "Crafting Beauty Since 2012",
    body: "Luxe Studio was founded with a simple belief — everyone deserves to feel beautiful. Our team of expert stylists and beauty therapists use only premium products to deliver results that exceed expectations.",
    highlights: ["20+ Expert Stylists", "Premium International Products", "Hygienic & Safe Environment", "Personalised Consultations"],
    image: "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=800&q=80",
  },
  services: [
    { id: 1, icon: "FaCut", title: "Hair Styling", description: "Cuts, colours, highlights, keratin treatments, and more by expert stylists.", image: "" },
    { id: 2, icon: "FaSpa", title: "Skin Treatments", description: "Facials, clean-ups, de-tan, and advanced skin care treatments.", image: "" },
    { id: 3, icon: "FaPaintBrush", title: "Makeup & Bridal", description: "Professional makeup for weddings, parties, and special occasions.", image: "" },
    { id: 4, icon: "FaLeaf", title: "Spa & Relaxation", description: "Body massages, aromatherapy, and full-body spa packages.", image: "" },
    { id: 5, icon: "FaShieldAlt", title: "Nail Art", description: "Manicure, pedicure, gel nails, and creative nail art designs.", image: "" },
    { id: 6, icon: "FaCalendarAlt", title: "Bridal Packages", description: "Complete bridal makeover packages for the most special day of your life.", image: "" },
  ],
  stats: [
    { value: 10000, label: "Happy Clients", suffix: "+" },
    { value: 20, label: "Expert Stylists", suffix: "+" },
    { value: 12, label: "Years of Excellence", suffix: "+" },
    { value: 4.9, label: "Average Rating", suffix: "★" },
  ],
  whyUs: {
    heading: "Why Choose Luxe Studio?",
    subheading: "Beauty redefined, experience elevated",
    points: [
      { icon: "FaCut", title: "Expert Stylists", description: "All stylists are trained at top academies with international certifications." },
      { icon: "FaLeaf", title: "Premium Products", description: "We use only Loreal, Wella, and Kerastase products for best results." },
      { icon: "FaShieldAlt", title: "Hygiene First", description: "Sterilised tools, disposable items, and a spotlessly clean environment." },
      { icon: "FaCalendarAlt", title: "Easy Booking", description: "Book online, via WhatsApp, or call us — appointments in minutes." },
    ],
  },
  gallery: [
    { id: 1, src: "https://images.unsplash.com/photo-1560066984-138dadb4c035?w=800&q=80", alt: "Salon Interior", category: "Studio" },
    { id: 2, src: "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=800&q=80", alt: "Hair Styling", category: "Hair" },
    { id: 3, src: "https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?w=800&q=80", alt: "Makeup", category: "Makeup" },
    { id: 4, src: "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80", alt: "Facial Treatment", category: "Skin" },
    { id: 5, src: "https://images.unsplash.com/photo-1604654894610-df63bc536371?w=800&q=80", alt: "Nail Art", category: "Nails" },
    { id: 6, src: "https://images.unsplash.com/photo-1519415510236-718bdfcd89c8?w=800&q=80", alt: "Bridal Makeup", category: "Makeup" },
  ],
  pricing: [
    { id: 1, name: "Basic Glow", price: "₹999", period: "per session", features: ["Haircut & Blow Dry", "Basic Facial", "Eyebrow Threading", "Nail Polish"], highlighted: false },
    { id: 2, name: "Luxe Experience", price: "₹2,499", period: "per session", features: ["Hair Colour / Highlights", "Advanced Facial", "Full Body Waxing", "Manicure & Pedicure", "Head Massage"], highlighted: true },
    { id: 3, name: "Bridal Package", price: "₹15,999", period: "complete package", features: ["Bridal Makeup", "Hair Styling", "Pre-Bridal Treatments", "Mehendi Consultation", "Day-of Touch-up"], highlighted: false },
  ],
  testimonials: [
    { id: 1, name: "Riya Sharma", role: "Bride", review: "Luxe Studio made me look absolutely stunning on my wedding day. The bridal package was worth every penny!", rating: 5, avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&q=80" },
    { id: 2, name: "Pooja Nair", role: "Regular Client", review: "I've been coming here for 3 years. The hair colour results are always perfect and the staff is so friendly.", rating: 5, avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&q=80" },
    { id: 3, name: "Ankit Mehta", role: "Men's Grooming", review: "Best haircut I've ever had. The barbers here really understand what you want. Highly recommend!", rating: 5, avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&q=80" },
  ],
  team: [
    { id: 1, name: "Nisha Kapoor", role: "Creative Director & Senior Stylist", bio: "15 years of expertise in hair artistry and colour.", image: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=400&q=80", social: { linkedin: "#", twitter: "#" } },
    { id: 2, name: "Rahul Bose", role: "Senior Hair Stylist", bio: "Trained at Toni & Guy London, specialising in cuts and colour.", image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&q=80", social: { linkedin: "#", twitter: "#" } },
    { id: 3, name: "Divya Menon", role: "Skin & Beauty Therapist", bio: "Certified aesthetician with expertise in advanced skin treatments.", image: "https://images.unsplash.com/photo-1594824476967-48c8b964273f?w=400&q=80", social: { linkedin: "#", twitter: "#" } },
  ],
  faq: [
    { id: 1, question: "Do I need to book an appointment?", answer: "Appointments are recommended to avoid waiting. Walk-ins are welcome based on availability." },
    { id: 2, question: "What hair colour brands do you use?", answer: "We use Loreal Professionnel, Wella Professionals, and Schwarzkopf for all colour services." },
    { id: 3, question: "How long does a bridal package take?", answer: "A full bridal package typically takes 4-6 hours. We recommend a trial session 2 weeks before the wedding." },
    { id: 4, question: "Do you offer home services?", answer: "Yes, we offer home services for bridal makeup and select beauty treatments within Mumbai." },
  ],
  cta: { heading: "Ready for Your Transformation?", subheading: "Book your appointment today and let us bring out your best.", buttonLabel: "Book Appointment", buttonLink: "/salon/contact" },
  footer: {
    tagline: "Look Good. Feel Amazing.",
    copyright: `© ${new Date().getFullYear()} Luxe Studio. All Rights Reserved.`,
    links: [
      { label: "Home", path: "/salon" },
      { label: "Services", path: "/salon/services" },
      { label: "Gallery", path: "/salon/gallery" },
      { label: "Contact", path: "/salon/contact" },
    ],
  },
  products: [
    { id: 1, name: "Kerastase Shampoo 250ml", category: "Hair Care", price: 1299, originalPrice: 1699, image: "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=600&q=80", description: "Nutritive bain satin shampoo for dry, sensitised hair. Salon-grade formula.", badge: "Best Seller", inStock: true },
    { id: 2, name: "Vitamin C Glow Kit", category: "Skin Care", price: 1899, originalPrice: 2500, image: "https://images.unsplash.com/photo-1556228578-8c89e6adf883?w=600&q=80", description: "Vitamin C serum + SPF moisturiser + eye cream — complete brightening routine.", badge: "Popular", inStock: true },
    { id: 3, name: "Gel Nail Polish Set", category: "Nails", price: 699, originalPrice: 999, image: "https://images.unsplash.com/photo-1604654894610-df63bc536371?w=600&q=80", description: "12 trending shades, chip-resistant formula, lasts up to 3 weeks.", badge: "New", inStock: true },
    { id: 4, name: "Argan Oil Hair Mask", category: "Hair Care", price: 849, originalPrice: 1200, image: "https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?w=600&q=80", description: "Deep conditioning mask with pure Moroccan argan oil. Repairs and adds shine.", badge: null, inStock: true },
  ],
  sections: { hero: true, about: true, services: true, whyUs: true, stats: true, gallery: true, pricing: true, testimonials: true, team: true, faq: true, cta: true, contact: true, products: true, enquireMode: false },
};

export default salonConfig;
